import "datatables.net-dt/js/dataTables.dataTables.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { toast } from 'react-toastify';
import { Modal, Popover } from 'antd';
import { useNavigate } from "react-router-dom";
import { api } from "../../utils/apiClient";
import { useSelector } from "react-redux";
import { API } from "../../config/constants";
import Pagination from "../../utils/Pagination";
import { formatDateToDMY, formatTime12Hour } from "../../utils/tools";
import ContentLoader from "../../utils/ContentLoader";
import { useState } from "react";
import SearchBy from "../../utils/SearchBy";
import { TableSortHeaders } from "../../utils/TableSortHeaders";
import ImagePreviewModal from "../../utils/ImagePreviewModal";

const { confirm } = Modal;

const MobileUserTable = ({
    mobileUsers,
    roles,
    onUserDeleted,
    onEdit,
    page,
    setPage,
    totalPages,
    totalEntries,
    sort,
    order,
    setOrder,
    setSort,
    search,
    setSearch
}) => {
    const viewPermissions = useSelector((state) => state.permission.rolePermissions) || [];
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const headerConfig = [
        { key: "id", label: "User ID", sortable: false },
        { key: "created_at", label: "Created Date", sortable: false },
        { key: "updated_at", label: "Updated At", sortable: false },
        { key: "avatar", label: "Profile", sortable: false },
        { key: "name", label: "User Name", sortable: false },
        { key: "email", label: "Email", sortable: false },
        { key: "facebook_id", label: "Facebook ID", sortable: false },
        { key: "google_id", label: "Google ID", sortable: false },
    ];

    const handleDelete = async (userId) => {
        try {
            setLoading(true);
            await api.delete(`/mobileUsers/${userId}`);
            toast.success("User deleted successfully!");
            if (onUserDeleted) onUserDeleted(userId);
        } catch (error) {
            console.error("Error deleting user:", error);
            toast.error("Failed to delete user: " + (error.response?.data?.message || error.message));
        } finally {
            setLoading(false);
        }
    };
    const showDeleteConfirm = (userId) => {
        confirm({
            title: 'Are you sure you want to delete?',
            okText: 'Yes',
            okType: 'primary',
            cancelText: 'No',
            centered: true,
            onOk() { handleDelete(userId); },
        });
    };

    if (loading) return <ContentLoader />;
    console.log("mobileuser=======>,", mobileUsers);

    return (
        <div className="card basic-data-table text-sm overflow-x-auto">
            <div className="card-header d-flex justify-content-end align-items-center global-header">
                <SearchBy
                    value={search}
                    onChange={(e) => {
                        setSearch(e.target.value);
                        setPage(1);
                    }}
                />
                {/* {viewPermissions.includes("user.create") && (
                    <button
                        className="btn btn-primary-600 global-add-btn"
                        type="button"
                        onClick={() => navigate("/create-user", { state: roles })}
                    >
                        <Icon
                            icon="fa6-regular:square-plus"
                            className="icon text-lg line-height-1"
                        />
                        Add
                    </button>
                )} */}
            </div>
            <div className="card-body card-body-modify">
                <div className="w-full overflow-x-auto">
                    <table className="table bordered-table mb-0 text-sm w-full min-w-max" id="dataTable">
                        <thead>
                            <tr>
                                {TableSortHeaders(headerConfig, sort, order, setSort, setOrder, setPage)}
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(mobileUsers) && mobileUsers.length > 0 ? (
                                mobileUsers.map((user) => (
                                    <tr key={user.id}>
                                        <td>{user.id || ""}</td>
                                        <td>
                                            {user.created_at
                                                ? `${formatDateToDMY(user.created_at)} ${formatTime12Hour(user.created_at)}`
                                                : ""}
                                        </td>
                                        <td>
                                            {user.updated_at
                                                ? `${formatDateToDMY(user.updated_at)} ${formatTime12Hour(user.updated_at)}`
                                                : ""}
                                        </td>
                                        <td>
                                            <ImagePreviewModal
                                                src={user.avatar || "/assets/images/logo-profile.png"}
                                                fallback="/assets/images/logo-profile.png"
                                                alt={user.name}
                                                thumbWidth={50}
                                                thumbHeight={50}
                                            />
                                        </td>
                                        <td>{user.name || ""}</td>
                                        <td>{user.email || ""}</td>

                                        <td>{user.facebook_id || "-"}</td>
                                        <td>{user.google_id || ""}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={8} className="text-center">
                                        No mobileUsers found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <Pagination
                    page={page}
                    setPage={setPage}
                    totalPages={totalPages}
                    totalEntries={totalEntries}
                />
            </div>
        </div>
    );
};

export default MobileUserTable;